import React, { useEffect, createElement } from 'react';
import { HeroSection } from './HeroSection';
import { TrustSection } from './TrustSection';
import { PainSection } from './PainSection';
import { TransformationSection } from './TransformationSection';
import { SolutionSection } from './SolutionSection';
import { BenefitsSection } from './BenefitsSection';
import { BonusSection } from './BonusSection';
import { ObjectionsSection } from './ObjectionsSection';
import { PurchaseSection } from './PurchaseSection';
import { FloatingCTA } from './FloatingCTA';
import { SocialProofPopup } from './SocialProofPopup';
import { StickyTimer } from './StickyTimer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function LandingPage() {
  // Initialize Meta Pixel and track PageView on mount
  useMetaPixel();
  // Set page title and meta tags for social sharing
  useEffect(() => {
    document.title = 'Guía de Esquejes';
    // Open Graph meta tags
    const metaTags = [{
      property: 'og:title',
      content: 'Guía de Esquejes'
    }, {
      property: 'og:description',
      content: 'Multiplica tus plantas sin perderlas en el intento. La guía paso a paso para hacer esquejes exitosos.'
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:image',
      content: 'https://cdn.magicpatterns.com/uploads/h45ZLkfyEb6KobfDUcdtpV/ChatGPT_Image_19_ene_2026,_03_20_12.png'
    }, {
      name: 'twitter:card',
      content: 'summary_large_image'
    }, {
      name: 'twitter:title',
      content: 'Guía de Esquejes'
    }, {
      name: 'twitter:description',
      content: 'Multiplica tus plantas sin perderlas en el intento. La guía paso a paso para hacer esquejes exitosos.'
    }, {
      name: 'twitter:image',
      content: 'https://cdn.magicpatterns.com/uploads/h45ZLkfyEb6KobfDUcdtpV/ChatGPT_Image_19_ene_2026,_03_20_12.png'
    }, {
      name: 'description',
      content: 'Multiplica tus plantas sin perderlas en el intento. La guía paso a paso para hacer esquejes exitosos.'
    }];
    metaTags.forEach(({
      property,
      name,
      content
    }) => {
      const selector = property ? `meta[property="${property}"]` : `meta[name="${name}"]`;
      let meta = document.querySelector(selector) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        if (property) meta.setAttribute('property', property);
        if (name) meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });
  }, []);
  return <main className="min-h-screen bg-[#fafaf9] font-sans text-gray-900 selection:bg-[#4a7c2c] selection:text-white pb-20 lg:pb-0 pt-9" data-id="element-75">
      <StickyTimer data-id="element-76" />
      <HeroSection data-id="element-77" />
      <PainSection data-id="element-78" />
      <TransformationSection data-id="element-79" />
      <SolutionSection data-id="element-80" />
      <BenefitsSection data-id="element-81" />
      <BonusSection data-id="element-82" />
      <PurchaseSection data-id="element-83" />
      <ObjectionsSection data-id="element-84" />
      <SocialProofPopup data-id="element-85" />
      <FloatingCTA data-id="element-86" />

      <footer className="bg-[#2d5016] text-white py-8 text-center text-sm opacity-90" data-id="element-87">
        <div className="container mx-auto px-4" data-id="element-88">
          <p data-id="element-89">
            © {new Date().getFullYear()} Guía para Hacer Esquejes. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>
    </main>;
}